import { render, staticRenderFns } from "./CustomAttributes.vue?vue&type=template&id=313e192b&scoped=true&"
import script from "./CustomAttributes.vue?vue&type=script&lang=ts&"
export * from "./CustomAttributes.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "313e192b",
  null
  
)

export default component.exports